import { BrandMark } from "@bw/shared/components";
import type { ImgHTMLAttributes } from "react";

interface LogoProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> {
  size?: number;
}

/** Full-detail Business authentication branding; activity actions use BadmintonMarkIcon. */
export function Logo({ size = 112, className, ...props }: LogoProps) {
  return (
    <BrandMark
      aria-hidden="true"
      className={className}
      {...props}
      size={size}
    />
  );
}
